import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { FileUploadField } from '@/components/common/form-fields';

interface BrandAssetsSectionProps {
  watch: UseFormWatch<any>;
  setValue: UseFormSetValue<any>;
  onRemoveLogo: (type: 'large' | 'small') => void;
  onViewLogo: (type: 'large' | 'small') => void;
  data?: any;
}

export default function BrandAssetsSection({
  watch,
  setValue,
  onRemoveLogo,
  data,
}: BrandAssetsSectionProps) {
  const large_logo_url = watch('large_logo_url');
  const small_logo_url = watch('small_logo_url');

  return (
    <div className="card">
      <h2 className="text-lg font-semibold mb-2">Brand Assets</h2>
      <p className="text-sm text-gray-600 mb-6">Upload logos that appear in your application navigation</p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Large Logo */}
        <FileUploadField
          label="Expanded Menu Logo"
          description="Displayed when the sidebar menu is expanded"
          currentFileUrl={large_logo_url !== undefined ? large_logo_url : data?.data?.large_logo_url}
          onFileChange={(url) => setValue('large_logo_url', url || '')}
          onRemove={() => onRemoveLogo('large')}
          accept="image/*"
          fileType="image"
          maxSizeMB={10}
          metadata={{ category: 'logo', type: 'expanded' }}
        />

        {/* Small Logo */}
        <FileUploadField
          label="Collapsed Menu Logo"
          description="Displayed when the sidebar menu is collapsed (compact icon)"
          currentFileUrl={small_logo_url !== undefined ? small_logo_url : data?.data?.small_logo_url}
          onFileChange={(url) => setValue('small_logo_url', url || '')}
          onRemove={() => onRemoveLogo('small')}
          accept="image/*"
          fileType="image"
          maxSizeMB={10}
          metadata={{ category: 'logo', type: 'collapsed' }}
        />
      </div>
    </div>
  );
}
